export default __webpack_public_path__ + "static/media/chatone.2cca2f33.mp3";